
import { Component, Vue, Watch } from 'vue-property-decorator';
import { store, StoreMutations } from '@/store';

@Component
export default class OpzioniReintegriComandi extends Vue {    
    
    get filtriApplicati(): boolean {
        let applicati = store.state.uiReintegri.filtri.idDistintaStatica.length > 0;
        applicati = applicati || store.state.uiReintegri.filtri.dataInserimentoDa.length > 0;
        applicati = applicati || store.state.uiReintegri.filtri.dataInserimentoA.length > 0;
        return applicati;
    }

    get toggleViewIcon(): string {
        return store.state.uiReintegri.listView ? 'mdi-apps' : 'mdi-format-list-bulleted';
    }

    private toggleView() {
        store.commit(StoreMutations.ReintegriUiToggleListView);
    }

    private mostraOpzioni() {
        store.commit(StoreMutations.SetOpzioniVisibili, true);
    }
}

